import { Shield } from 'lucide-react';

export function WarRoomLoadingState() {
    return (
        <div className="min-h-screen bg-[#050505] text-gray-300 font-sans flex items-center justify-center">
            <div className="flex flex-col items-center gap-4 animate-pulse">
                <Shield className="w-12 h-12 text-blue-900/50" />
                <p className="text-gray-600 font-mono text-sm">INITIALIZING WAR ROOM...</p>
            </div>
        </div>
    );
}
